

















































































/* Mixins */
import Vue from 'vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data Types */
import { EEntities } from '@/types'
import { IHomeTableItem } from '@/types/data-objects/items'

export default Vue.extend({
  name: 'HomeTableListItemResponsive',

  props: {
    item: {
      type: Object as () => IHomeTableItem,
      required: true,
    },
    fromAll: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      RouteAssistant,
    }
  },

  computed: {
    statusChickletWidth(): string {
      return this.$screen.isMobile(this.$mq) ? '120px' : ''
    },
    isConversation(): boolean {
      if (this.item.customer) {
        return true
      }
      return false
    },
    isTask(): boolean {
      return !this.isConversation
    },
  },
  methods: {
    getHomeRoute(item: IHomeTableItem) {
      switch (item.entityType) {
        case EEntities.MAILBOXES:
          return RouteAssistant.getMailboxRoute(
            this.$route.params.accountId,
            item.parent.id,
            item.parent.name,
          )
        case EEntities.PROJECTS:
          return RouteAssistant.getProjectLandingRoute(
            this.$route.params.accountId,
            item.parent.id,
            this.$permissions,
            item.parent.name,
          )
      }
    },
    hasDesc(item: IHomeTableItem): boolean {
      return item.text && item.text.length > 0
    },
    hasCounts(item: IHomeTableItem): boolean {
      return (
        this.hasLinkedTasks(item) ||
        this.hasLinkedConversations(item) ||
        this.hasThreadCount(item) ||
        this.hasChecklistCount(item)
      )
    },
    hasLinkedTasks(item: IHomeTableItem): boolean {
      return item.linkedTasksCount > 0
    },
    hasLinkedConversations(item: IHomeTableItem): boolean {
      return item.linkedConversationsCount && item.linkedConversationsCount > 0
    },
    hasThreadCount(item: IHomeTableItem): boolean {
      return item.threadCount > 0
    },
    hasChecklistCount(item: IHomeTableItem): boolean {
      return item.totalChecklistItemsCount > item.completedChecklistItemsCount
    },
  },
})
